const VeticScreenSaver = () => {
  return (
    <div className="flex flex-col items-center justify-center h-[var(--mirror-frame-height,100vh)] w-full bg-gradient-to-br from-blue-100 via-white to-blue-200 animate-gradientShift overflow-hidden">
      {/* Vetic Hero Image */}
      <img
        src="https://vetic-img.s3.ap-south-1.amazonaws.com/website/Website-Astro/home_page_image/Hero+Image_Home+Page+desktop.webp"
        alt="Vetic Pet"
        className="w-64 h-64 md:w-80 md:h-80 object-cover rounded-full shadow-2xl mb-8 animate-softPulse"
      />

      {/* Heading */}
      <h1 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-3 animate-fadeInDown">
        Welcome to Vetic
      </h1>

      {/* Tagline */}
      <p className="text-lg sm:text-xl text-gray-600 text-center max-w-lg animate-fadeInUp [animation-delay:0.8s] opacity-50 whitespace-nowrap">
        Trusted, human-grade care for your beloved pets 🐾
      </p>

    </div>
  );
};

export default VeticScreenSaver;
